import { FiltersV2Panel, FiltersV2StoreContextProvider } from "PFApp/components/filters_v2";
import { Stack } from "PFComponents/containers";
import { PageTarget } from "PFTypes/saved_filters";
import { useTranslation } from "react-i18next";

import css from "./interested.module.scss";
import { InterestedContextProvider } from "./interested_context";
import InterestedPageHeader from "./interested_page_header";
import InterestedTable from "./interested_table";
import PropertiesPanel from "./properties_panel";

type ActivityInterestedProps = {
  handleInterestsCountChange: (count: number) => void;
};

export const ActivityInterested = ({ handleInterestsCountChange }: ActivityInterestedProps) => {
  const { t } = useTranslation("activities");

  return (
    <FiltersV2StoreContextProvider collection={PageTarget.ActivitiesInterests}>
      <InterestedContextProvider onInterestsCountChange={handleInterestsCountChange}>
        <Stack
          gap="spacingLg"
          className={css.container}
          role="tabpanel"
          aria-label={t("show.tabs.interested")}
          qaId="ActivityPage.interestedTab"
        >
          <InterestedPageHeader />
          <InterestedTable />
        </Stack>
        <FiltersV2Panel />
        <PropertiesPanel />
      </InterestedContextProvider>
    </FiltersV2StoreContextProvider>
  );
};
